export const IMAGE_ACCEPTED_TYPES = ['image/png', 'image/jpeg', 'image/heif', 'image/heic', 'image/webp'];
export const IMAGE_TYPE_INPUT = IMAGE_ACCEPTED_TYPES.join(',');
export const IMAGE_MAX_SIZE = 10 * 1024 * 1024; // 10MB
export const IMAGE_LIMIT = 10;
